
/**
 * Convert from custom (aka canonical) "2020/10/03 19:01:14.093Z" to "2020-10-03T19:01:14.093Z"
 * 
   For some reason (e.g. on Chrome Mobile iOS 135.0.7049) we are getting 
   `RangeError: Invalid Date` errors when trying to parse custom "canonical" iso dates from getDate().
   See https://app.rollbar.com/a/biblesocieties/fix/items?isSnoozed=false&prj=683454&query=Invalid+Date
   Dates that come from _LevelupDB.getDate() use a custom iso format 
   (via convertToCanonicalDateTimeFormat) that are not compatible with new Date(date) Mobile iOS. 
   So, manually transform it back into the original iso format before 
   using new Date(modDate) to validate it
 */
export function convertFromCanonicalTimestamp(customDate: string) {
    const strBuilder = []
    const dtParts = customDate.split(' ')
    const [yyyy, MM, dd] = dtParts[0].split('/')
    const [hh, mm, ss] = dtParts[1]?.split(':') || []
    strBuilder.push(yyyy) // iso dates will be fully added here 
    if (MM) strBuilder.push('-' + MM)
    if (dd) strBuilder.push('-' + dd)
    if (hh) strBuilder.push('T' + hh)
    if (mm) strBuilder.push(':' + mm)
    if (ss) strBuilder.push(':' + ss)
    const newDate = strBuilder.join('')
    try {
        return new Date(newDate)
    } catch (e) {
        const msg = `invalid date '${newDate}' from '${customDate}': ${String(e)}`
        console.error(msg)
        throw new Error(msg)
    }
}

export const parseCustomDateOrNaN = (customIso: string) => {
    try {
        return convertFromCanonicalTimestamp(customIso).getTime()
    } catch (e) {
        return NaN
    }
}
